var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
var percentToMagnification = function (value) {
    return value / 100;
};
export var percent = (_a = {},
    _a[UnitSuffix.Percent] = noConvert,
    _a[UnitSuffix.Magnification] = percentToMagnification,
    _a);
//# sourceMappingURL=percent.js.map